import { render, staticRenderFns } from "./levelConfig.vue?vue&type=template&id=39da7165&scoped=true"
import script from "./levelConfig.vue?vue&type=script&lang=js"
export * from "./levelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da7165",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39da7165')) {
      api.createRecord('39da7165', component.options)
    } else {
      api.reload('39da7165', component.options)
    }
    module.hot.accept("./levelConfig.vue?vue&type=template&id=39da7165&scoped=true", function () {
      api.rerender('39da7165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/commission/levelConfig.vue"
export default component.exports